var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.245 4l-11.245 14.374-11.219-14.374-.781.619 12 15.381 12-15.391-.755-.609z"}));
}

AngleDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fillRule":"evenodd","clipRule":"evenodd"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
